import { CopyOutlined } from "@ant-design/icons";
import { Button, message } from "antd";


const CopyButton: React.FC<{ content: string }> = ({ content }) => {
    return <Button type="ghost" icon={<CopyOutlined />} onClick={() => { navigator.clipboard.writeText(content); message.success('Content copied!'); }}>Copy</Button>
}

export default CopyButton;